/* eslint react/prop-types: 0 */
import React, { useState } from 'react';
import ConfigAccordionBase from '../../../components/3modules/Config/ConfigAccordionBase';
import { Text } from '../../../components/1elements';
import MapMarkerPicker from '../MapMarkerPicker';
import MarkerListFullEditor from '../MarkerListFullEditor';

import './styles.scss';

const EntityTypeMarkerConfigAccordion = ({
  onEditMode,
  defaultMarker,
  entityTypeList,
  entityTypeColors,
  setEntityTypeColors
}) => {
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const selectedMarker = entityTypeColors[selectedRowIndex];

  const updateMarkerColor = (data) => {
    setEntityTypeColors((prev) => {
      const newList = [...prev];
      newList[selectedRowIndex] = {
        ...prev[selectedRowIndex],
        color: data.color
      };
      return newList;
    });
  };

  return (
    <ConfigAccordionBase
      className={'EntityTypeMarkerConfigAccordion-root'}
      label={'Entity Type Marker'}
      onEditMode={onEditMode}
    >
      {!onEditMode && !entityTypeColors.length && (
        <Text type={'span'}>
          No entity type markers configured.
          <br />
          Please enable edit mode to configure markers.
        </Text>
      )}
      <div>
        {onEditMode && <Text type={'h9'}>Marker</Text>}
        <MarkerListFullEditor
          markerSettings={entityTypeColors}
          setMarkerSettings={setEntityTypeColors}
          selectList={entityTypeList}
          selectedRowIndex={selectedRowIndex}
          setSelectedRowIndex={setSelectedRowIndex}
          className={'EntityTypeMarkerConfigAccordion-editorList'}
          onEditMode={onEditMode}
          defaultMarker={defaultMarker}
        />
      </div>
      {onEditMode && selectedRowIndex !== null && (
        <div>
          <Text type={'h9'}>Color</Text>
          <MapMarkerPicker
            className={'EntityTypeMarkerConfigAccordion-mapMarkerPicker'}
            selectedMarker={selectedMarker}
            updateMarker={updateMarkerColor}
            showColor={true}
            showName={false}
            showIcon={false}
          />
        </div>
      )}
    </ConfigAccordionBase>
  );
};

export default EntityTypeMarkerConfigAccordion;
